module.exports = __webpack_public_path__ + "static/media/Lato-Italic.56c4cb26.ttf";